// extracted by mini-css-extract-plugin
export default {"button":"DeleteUser_button__a1Uup"};